module.exports = __webpack_public_path__ + "static/media/img-newtaipeicity-en-mobile.7525e50e.svg";